import React, { Component } from "react";
import { connect } from "react-redux";
import School from "../models/School";
import ApiService from "./ApiService";
import { IRootState } from "../store";
import PageTitle from "./PageTitle";
import * as _ from "lodash";

interface SchoolPageTitleProps {
    title?: string;
    tenantId: string;
    schoolCode: string;
    apiService: ApiService;
    reverse?: boolean;
}

interface SchoolPageTitleState {
    title: string;
    school?: School;
}

class SchoolPageTitle extends Component<SchoolPageTitleProps, SchoolPageTitleState>
{
    constructor(props: Readonly<SchoolPageTitleProps>) {
        super(props);

        this.state = {
            title: ""
        };
    }

    private setTitleState() {
        let titleParts = [];

        // School name
        if (this.state.school) {
            titleParts.push(this.state.school.schoolName);
        }

        // Title
        if (this.props.title) {
            titleParts.push(this.props.title);
        }

        if (this.props.reverse === true) {
            _.reverse(titleParts);
        }

        this.setState({
            title: titleParts.join(" - ")
        });
    }

    async componentDidMount() {
        this.setTitleState();
        await this.loadSchool();
        this.setTitleState();
    }

    async componentDidUpdate(prevProps: Readonly<SchoolPageTitleProps>, prevState: Readonly<SchoolPageTitleState>, snapshot?: any) {
        if (this.props.title !== prevProps.title) {
            this.setTitleState();
        }

        if (this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode) {
            await this.loadSchool();
            this.setTitleState();
        }
    }

    async loadSchool() {
        if (this.props.tenantId && this.props.schoolCode) {
            let school = await this.props.apiService.getSchool(this.props.tenantId, this.props.schoolCode);
            this.setState({ school });
        }
    }

    render() {
        return (
            <PageTitle title={this.state.title} />
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): SchoolPageTitleProps => {
        return {
            tenantId: ownProps.tenantId,
            schoolCode: ownProps.schoolCode,
            title: ownProps.title,
            apiService: state.auth.apiService,
            reverse: ownProps.reverse
        };
    }
)(SchoolPageTitle)
